<template>
  <div>
    <div class="app-container app-container--with-progress">
      <div class="app-container-route">
        <MembershipType />
        <router-view />
      </div>
      <div class="app-container-progress">
        <progress-bar />
      </div>
    </div>
    <spinner />
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressBar from "@/components/ProgressBar.vue";
import Spinner from "@/components/Spinner";
import MembershipType from "@/components/MembershipType.vue";

export default {
  name: "Membership",
  components: {
    ProgressBar,
    Spinner,
    MembershipType,
  },
  setup() {},
};
</script>
